import { createContext, useState, useEffect, ReactNode } from "react";
import React from "react";
import { UserRoles, UserRolesEnum } from "../typings";
interface AuthContextType {
  isAuthenticated: boolean;
  role: UserRoles;
  userId: number | null;
  login: (token: string, role: string, userId: number) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => !!localStorage.getItem("token"));
  const [role, setRole] = useState<UserRoles>(() => (localStorage.getItem("role") as UserRoles) ?? UserRolesEnum.STUDENT);
  const [userId, setUserId] = useState<number | null>(() => {
    const storedUserId = localStorage.getItem("userId");
    return storedUserId ? parseInt(storedUserId, 10) : null;
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedRole = localStorage.getItem("role") as UserRoles;
    const storedUserId = localStorage.getItem("userId");
    setIsAuthenticated(!!token);

    if (token) {
      if (storedRole) setRole(storedRole);
      if (storedUserId) setUserId(parseInt(storedUserId, 10));
    }
  }, []);

  // Listen for 401 Unauthorized events dispatched by the Axios interceptor
  useEffect(() => {
    const handleUnauthorized = () => {
      logout();
    };
    window.addEventListener("auth:unauthorized", handleUnauthorized);
    return () => {
      window.removeEventListener("auth:unauthorized", handleUnauthorized);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = (token: string, role: string, userId: number) => {
    localStorage.setItem("token", token);
    localStorage.setItem("role", role);
    localStorage.setItem("userId", userId.toString());
    setRole(role as UserRoles);
    setUserId(userId);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("userId");
    setIsAuthenticated(false);
    setUserId(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, role, userId }}>
      {children}
    </AuthContext.Provider>
  );
};
